<script setup>
import {defineProps} from 'vue'

defineProps({
  showPreloader: {
    default: false,
    type: Boolean,
  },
  name: {
    default: '',
    type: String,
  },
  isSmallInput: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div v-if="showPreloader" class="input-preloader-wrapper" v-bind="$attrs">
    <div class="visibility-hidden">
      <slot />
    </div>

    <div class="input-preloader-overlay">
      <span class="input-preloader-text"
      ><span v-if="!isSmallInput">Loading </span>{{ name }}<span class="animated_text-dots"></span>
      </span>
    </div>
  </div>

  <template v-else>
    <slot />
  </template>
</template>
